// src/portals/creator/components/MobileNavDrawer.js
import React from "react";
import { X } from "lucide-react";

const MobileNavDrawer = ({ isOpen, onClose, children, footerContent }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`absolute inset-0 bg-black/60 z-30 transition-opacity ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />
      {/* Drawer - Full height with flex layout */}
      <div
        className={`absolute top-0 left-0 h-screen w-72 bg-slate-800 text-white z-40 transform transition-transform flex flex-col ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Header - Fixed */}
        <div className="flex-shrink-0 p-4 flex justify-between items-center border-b border-slate-700">
          <h2 className="font-bold">Menu</h2>
          <button onClick={onClose} className="p-2 hover:bg-slate-700 rounded" aria-label="Close menu">
            <X size={24} aria-hidden="true" />
          </button>
        </div>
        
        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-4">{children}</div>
        </div>
        
        {/* Sticky Footer - Fixed at bottom */}
        {footerContent && (
          <div className="flex-shrink-0 border-t border-slate-700">
            {footerContent}
          </div>
        )}
      </div>
    </>
  );
};

export default MobileNavDrawer;
